// extracted by mini-css-extract-plugin
module.exports = {"mapArea":"MapArea_mapArea__mMIWC"};